// App
import { input, toggle, select } from '../../components/form/form'
import { Menu } from '../../layout/menu/menu'
import { Sidebar } from '../../layout/sidebar/sidebar'
import { HeaderUser } from '../../components/user/user'
import { DatePicker } from '../../components/datepicker/DatePicker'
import { ToolType } from '../../components/tooltype/ToolType'
import { ShowHiddenElement } from './methods/ShowHiddenElement'
import { CallModalWindow } from './methods/CallModalWindow'

window.addEventListener('DOMContentLoaded', function() {
  toggle('js-toggle')
  input('js-input')
  select('js-select')
  Menu('js-menu')
  Sidebar('js-sidebar')
  HeaderUser('js-user')
  DatePicker('js-date')
  ToolType('js-tooltype')
  ShowHiddenElement('js-animation-height')
  CallModalWindow()
})
